(function ($) {
    $(document).ready(function () {
        function consentLocatorHandler() {
            var $apps = $('[data-wep2-app]');
            var apiurl = "";
            $('.locator-spinner').removeClass('d-none');
            $apps.each(function () {
                var self = $(this);
                var appName = $(this).data('wep2-app');
                var mapurl = $(this).data('locatormapsettingsapi');
                apiurl = mapurl;
                $.ajax({
                    type: 'POST',
                    url: apiurl,
                    success: function (data, status, xhr) {
                        $('.locator-spinner').addClass('d-none');
                        var jsonoutput = JSON.parse(data.OutputJson);
                        var jsonstring = JSON.stringify(jsonoutput);
                        self.attr('data-app-config', jsonstring);
                        loadAssetsByType(appName);
                        setTimeout(function () {
                            locatorMapGAEventsHandler();
                        }, 3000);
                    },
                    error: function (xhr) {
                        $('.locator-spinner').addClass('d-none');
                    }
                });
            });
            $('.user_consent_content').css('display', 'none');
        }

        function consentDetailPageHandler() {
            var JSSrc = $('#mapapi-script').attr('data-mapscript-src');
            $('body').append('<script id="jsmapapi"  src=' + JSSrc + '/>');
            setTimeout(function () {
                mapdetailinit();
            }, 3000);

            $('.user_consent_content').css('display', 'none');
            $('.component.sp01-map').removeClass('hide-map-div');
        }

        $('.user_consent_button').click(function () {
            consentLocatorHandler();
        });

        $('.user_consent_button').keydown(function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                consentLocatorHandler();
            }
        });

        $('.user_consent_detailpage').click(function () {
            consentDetailPageHandler();
        });

        $('.user_consent_detailpage').keydown(function (event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                consentDetailPageHandler();
            }
        });
    });
}(window.jQuery));